/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import type {PortableTextComponents} from '@portabletext/react';
import Link from 'next/link';

const wysiwygComponents: PortableTextComponents = {
  block: {
    small: ({children}) => <p className="wysiwyg text-sm">{children}</p>,
    large: ({children}) => <p className="wysiwyg text-lg">{children}</p>,
    h1: ({children}) => <h1 className="wysiwyg">{children}</h1>,
    h2: ({children}) => <h2 className="wysiwyg">{children}</h2>,
    h3: ({children}) => <h3 className="wysiwyg">{children}</h3>,
    h4: ({children}) => <h4 className="wysiwyg">{children}</h4>,
  },
  list: {
    number: ({children}) => <ol className="wysiwyg">{children}</ol>,
    bullet: ({children}) => <ul className="wysiwyg">{children}</ul>,
  },
  marks: {
    highlight: ({children}) => <span className="wysiwyg text-primary">{children}</span>,
    sup: ({children}) => <sup className="wysiwyg">{children}</sup>,
    externalLink: ({children, value}) =>
      value.href ? (
        <Link className="link" href={value.href as string} target="_blank">
          {children}
        </Link>
      ) : null,
    internalLink: ({children, value}) => {
      if (!value.slug) {
        // eslint-disable-next-line no-console
        console.warn(
          'Missing slug for internal link. Check your query to make sure it handles internal references in the block query'
        );
      }

      return (
        <Link className="link" href={(value.slug as string) ?? ''}>
          {children}
        </Link>
      );
    },
  },
};

export default wysiwygComponents;
